import { traitsContract } from "config";
import { useMemo } from "react";
import { useContractRead } from "wagmi";

const useIsTraitsApprovedForAll = (
  operator: string,
  address?: string
): [boolean | undefined, () => void] => {
  const args = useMemo(
    () => address && operator && [address, operator],
    [address, operator]
  );

  const [{ data: isApproved }, readAllowance] = useContractRead(
    {
      addressOrName: traitsContract.address,
      contractInterface: traitsContract.interface,
    },
    "isApprovedForAll",
    {
      args,
    }
  );

  return [isApproved as unknown as boolean, readAllowance];
};

export default useIsTraitsApprovedForAll;
